<template>
  <md-app md-waterfall md-mode="fixed">
    <md-app-toolbar class="md-primary">
      <div class="md-toolbar-row">
        <md-button class="md-icon-button" v-on:click="toggleMenuVisibility">
          <md-icon>menu</md-icon>
        </md-button>
        <div class="md-toolbar-section-start">
          <span class="md-title">
            <span v-lang.appName></span> <span v-if="isTestEnv">- <span v-lang.testEnvTitle></span></span>
          </span>
        </div>
      </div>
    </md-app-toolbar>
    <md-app-drawer :md-active.sync="menuVisible" md-persistent="mini" md-permanent="clipped">
      <md-list>
        <md-list-item :to="{ name: 'HomePage' }">
          <md-icon>home</md-icon>
          <span class="md-list-item-text" v-lang.homePage></span>
        </md-list-item>

        <md-list-item md-expand :md-expanded.sync="expandNewsMember" v-if="canManageAny">
          <md-icon>group</md-icon>
          <span class="md-list-item-text" v-lang.membership></span>

          <md-list slot="md-expand">
            <md-list-item class="md-inset" :to="{ name: 'MemberListPage' }" v-if="canManageMember">
              <md-icon>verified_user</md-icon>
              <span class="md-list-item-text" v-lang.control></span>
            </md-list-item>
          </md-list>
        </md-list-item>

        <md-list-item md-expand :md-expanded.sync="expandNewsOrganization" v-if="canManageAny">
          <md-icon>location_city</md-icon>
          <span class="md-list-item-text" v-lang.organizations></span>

          <md-list slot="md-expand">

            <md-list-item class="md-inset" :to="{
              name: 'OrganizationListPage',
              query: { parent_id: $config.rootParentId }
              }" v-if="canManageOrg">
              <md-icon>verified_user</md-icon>
              <span class="md-list-item-text" v-lang.control></span>
            </md-list-item>

          </md-list>
        </md-list-item>

        <md-list-item md-expand :md-expanded.sync="expandNewsDocument" v-if="canManageAny">
          <md-icon>description</md-icon>
          <span class="md-list-item-text" v-lang.documents></span>

          <md-list slot="md-expand">

            <md-list-item class="md-inset" :to="{ name: 'DocumentListComponent' }" v-if="canManageDoc">
               <md-icon>verified_user</md-icon>
              <span class="md-list-item-text" v-lang.control></span>
            </md-list-item>
          </md-list>
        </md-list-item>

        <md-list-item v-on:click="logout">
          <md-icon>exit_to_app</md-icon>
          <span class="md-list-item-text" v-lang.signOut></span>
        </md-list-item>
      </md-list>
    </md-app-drawer>
    <md-app-content>
      <slot name="dash-content"></slot>
    </md-app-content>
  </md-app>
</template>

<script>
import Auth from '@/common/auth'
import UserPreferences from '@/common/user/preferences'

export default {
  name: 'AppDashboard',
  data () {
    return {
      menuVisible: this.getMenuVisibilityInitValue(),
      expandNewsMember: false,
      expandNewsOrganization: false,
      expandNewsDocument: false,
      canManageAny: Auth.CanManageAny(),
      canManageOrg: Auth.CanManageOrgs(),
      canManageMember: Auth.CanManageMembers(),
      canManageDoc: Auth.CanManageDocs(),
      isTestEnv: process.env.APP_ENV !== 'prod'
    }
  },
  watch: {
    expandNewsMember () {
      this.$router.push({ name: 'ViewListMember' })
    },
    expandNewsOrganization () {
      this.$router.push({ name: 'ViewListOrganization' })
    },
    expandNewsDocument () {
      this.$router.push({ name: 'ViewListDocument' })
    }
  },
  methods: {
    getMenuVisibilityInitValue () {
      const value = UserPreferences.Get('leftMenuVisible')
      if (value !== undefined) {
        return value
      }

      const smallScreenWidth = 800
      const windowWidth = screen ? screen.width : document.body.clientWidth
      if (windowWidth > smallScreenWidth) {
        return true
      } else if (windowWidth <= smallScreenWidth) {
        return false
      }
    },
    toggleMenuVisibility () {
      this.menuVisible = !this.menuVisible

      UserPreferences.Set('leftMenuVisible', this.menuVisible)
    },
    logout () {
      Auth.Logout()
    }
  }
}
</script>

<style lang="scss" scoped>
.md-app {
  height: 100%;

  .md-app-content {
    position: relative;
  }

  .md-drawer {
    width: 250px;
    position: inherit;
    max-width: calc(100vw - 125px);
  }

  .md-list-item-container {
    .md-list-item-text {
      color: #448aff;
      color: var(--md-theme-default-primary-on-background, #448aff);
    }
  }
}
.md-drawer.md-permanent {
  transform: none;
}

</style>



// WEBPACK FOOTER //
// src/components/ui/AppDashboard.vue